<script>
    import {PolarArea} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: PolarArea,
        mounted() {
            this.renderChart(
                {
                    labels: ['Limón', 'Plátano', 'Sandía', 'Plata', 'Manzana'],
                    datasets: [
                        {
                            label: 'Frutas (ton)',
                            backgroundColor: [hexToRgba('#ff0002', 70), hexToRgba('#00ff1c', 70), hexToRgba('#002fff', 70), hexToRgba('#00fcff', 70), hexToRgba('#ff5900', 70)],
                            fill: true,
                            data: [108132, 95044, 83217, 59247, 53517]
                        }
                    ]
                },
                {
                    responsive: true,
                    maintainAspectRatio: true,
                    scale: {
                        beginAtZero: true
                    },
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: true,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
